<template>
    <div v-if="this.showModal == 'true'" ref="confirmationTarget" >
        <div class="delete-container text-left" id="confirmationBox" ref="confirmationBox"> 
        <h4 class="mb-10 bold">アカウントを削除しますか？</h4>
        <p class="bold">アカウントを削除すると以下の情報が全て失われます。</p>
        <ul class="mt-0">
            <li class="bold">メールアドレスとパスワード</li>
            <li class="bold">検索履歴</li>
            <li class="bold">単語帳</li>
        </ul>
        <slot name="checkbox">
        </slot>
        <slot name="deleteButton" >
        </slot>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isChecked: false,
            showModal: 'false',
        };
    },
    methods: {
        showConfirmation() {
            this.showModal = 'true';
            this.$nextTick(() => {
                this.$refs.confirmationBox.scrollIntoView({ behavior: 'smooth' });
                });
            },
        closeConfirmation() {
            this.showModal = 'false';
        },
    },
};
</script>
<style></style>